// extracted by mini-css-extract-plugin
export default {"wrapper":"field-wrapper_wrapper__+ixjv","w50":"field-wrapper_w50__Li0SH","top":"field-wrapper_top__IiQoW","error":"field-wrapper_error__PeR16","center":"field-wrapper_center__gksrU"};